exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(max-width:600px){.select-country-collection[data-v-2db49ed6] div:first-child{width:100%}}@media only screen and (min-width:1200px){.select-country-collection[data-v-2db49ed6] ul{padding:0}.select-country-collection[data-v-2db49ed6] li{margin-bottom:0}}", ""]);

// exports
